/**
 * 配車計画 ドライバー
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../constants/httpConst'

 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/allocations/drivers`

 const allocation_driver = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     * 配車計画 ドライバー一覧
     * @param commit
     * @param target_date
     * @param start_date
     * @param end_date
     * @param type
     * @param sort
     * @return {Promise<unknown>}
     */
    index ({ commit }, { target_date, start_date, end_date, type, without_instruction, sort }) {
      const params = {
        target_date: target_date,
        start_date: start_date,
        end_date: end_date,
        type: type,
        without_instruction: without_instruction,
        sort: sort
      }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},

 }

 export default allocation_driver
